import type { LogInput } from '../types/log-input';

export function log(input: LogInput) {
  console.log('log:', input);
}
